
const hostMedia = 'eventsgo/media/'
// 获取接口人W3账号
export const GET_USER_ACCOUNT_LIST = hostMedia + 'services/eventsgo/config/orgCfgService/findOrgCfgUserList'
